module.exports = __webpack_public_path__ + "static/media/human_body_2.74b4077e.png";